export default __webpack_public_path__ + "static/media/Scientists_Row_Mobile.ec9be4ca.png";